import { FC, useState } from 'react'
import { InsetSection, Select } from 'admin/lib/Forms'
import _ from 'lodash'

import { useWasteCarriers, useWasteFacilities } from 'admin/lib/Api/queries'
import styled from 'styled-components'

export const DevelopmentPlayground: FC = () => {
  const [carriersSearch, setCarriersSearch] = useState<null | string>(null)
  const [facilitiesSearch, setFacilitiesSearch] = useState<null | string>(null)

  const carriers = useWasteCarriers(carriersSearch)
  const facilities = useWasteFacilities(facilitiesSearch)

  return (
    <Container>
      <InnerContainer>
        <InsetSection>
          <label>Carriers</label>
          <Select
            showSearch
            loading={carriers.isFetching}
            placeholder={carriers.isFetching ? 'Fetching' : 'Select a Carrier'}
            filter={false}
            options={
              carriers.data?.pages &&
              _.flatMap(carriers.data.pages, page => page?.items ?? []).map(
                carrier => {
                  return {
                    value: carrier.carrierLicenceId,
                    label: `${carrier.carrierLicenceId}: ${carrier.name}`
                  }
                }
              )
            }
            onSearch={setCarriersSearch}
            onBottomReached={
              carriers.hasNextPage ? carriers.fetchNextPage : undefined
            }
          />

          <label>Facilities</label>
          <Select
            showSearch
            loading={facilities.isFetching}
            placeholder={
              facilities.isFetching ? 'Fetching' : 'Select a Facility'
            }
            filter={false}
            options={
              facilities.data?.pages &&
              _.flatMap(facilities.data.pages, page => page?.items ?? []).map(
                facility => {
                  return {
                    value: facility.permitId,
                    label: `${facility.permitId}: ${facility.operator}`
                  }
                }
              )
            }
            onSearch={setFacilitiesSearch}
            onBottomReached={
              facilities.hasNextPage ? facilities.fetchNextPage : undefined
            }
          />
        </InsetSection>
      </InnerContainer>
    </Container>
  )
}

const Container = styled.div`
  padding-top: 2rem;

  display: flex;
  justify-content: center;
`

const InnerContainer = styled.div`
  width: 30rem;
`
